import { RestUrl } from "../common/cyan.types";

export class FolderSharingSettingUrl {
  public static getFolderSharingSetting: RestUrl = ["GET", "/folder/sharing/setting"];
  public static updateFolderSharingSetting: RestUrl = ["PUT", "/folder/sharing/setting"];
}
